import React from "react"
import { useSafeAreaInsets } from "react-native-safe-area-context"
import { Platform, StyleSheet, TouchableOpacity, View } from "react-native"
import ShareIcon from "@/assets/icons/share-icon.svg"
import StreetViewIcon from "@/assets/icons/street-view-dude.svg"
import FavoriteIcon from "@/assets/icons/heart.svg"
import IsFavoriteIcon from "@/assets/icons/heart-filled.svg"
import RingingNotifyIcon from "@/components/buttons/RingingNotifyIcon"

interface SubjectSelectionButtonsProps {
  displaysNotificationIcon: boolean
  notificationsEnabled: boolean
  onNotify: () => void
  isFavorite: boolean
  onFavorite: () => void
  onShare: () => void
  onStreetView: () => void
}

export const SubjectSelectionButtons: React.FC<
  SubjectSelectionButtonsProps
> = ({
  displaysNotificationIcon,
  notificationsEnabled,
  onNotify,
  isFavorite,
  onFavorite,
  onShare,
  onStreetView,
}) => {
  const insets = useSafeAreaInsets()
  return (
    <View
      style={[
        buttonStyles.buttonContainer,
        { top: Platform.OS === "web" ? 42 : insets.top },
      ]}
    >
      <View
        className={
          "bg-off-white/35 flex-row justify-center items-center px-5 rounded-full gap-5 py-2"
        }
      >
        {displaysNotificationIcon && (
          <RingingNotifyIcon
            notificationsEnabled={notificationsEnabled}
            onNotify={onNotify}
          />
        )}

        <TouchableOpacity
          hitSlop={8}
          testID={"favorite-button"}
          onPress={onFavorite}
        >
          {isFavorite ? (
            <IsFavoriteIcon width={22} height={24} />
          ) : (
            <FavoriteIcon width={22} height={24} />
          )}
        </TouchableOpacity>

        <TouchableOpacity
          hitSlop={8}
          testID={"share-icon-button"}
          onPress={onShare}
        >
          <ShareIcon width={24} height={26} />
        </TouchableOpacity>
        <TouchableOpacity
          hitSlop={8}
          testID={"street-view-icon-button"}
          onPress={onStreetView}
        >
          <StreetViewIcon width={23} height={24} />
        </TouchableOpacity>
      </View>
    </View>
  )
}

const buttonStyles = StyleSheet.create({
  buttonContainer: {
    position: "absolute",
    right: 16,
  },
  backgroundCircle: {
    borderRadius: 20,
    width: 90,
    height: 42,
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "center",
    paddingHorizontal: 10,
  },
})
